import Base64 from './base64Code.js'
export const validateImage = function(pathImg) {
  var ImgObj = new Image();
  ImgObj.src = pathImg;
  if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
    return true;
  } else {
    return false;
  }
}

export const base64Code = function(val, type) { // 0 加密 1解密
  var result = ''
  var base = new Base64()
  if (type === 0) result = base.encode(val)
  if (type === 1) result = base.decode(val)
  return result
}

// 去掉空属性的值
export const deletObjectEmptyAttribute = function(obj) {
  if (obj.constructor === Object) {
    let o = {}
    for (let key in obj)
      if (obj[key] !== '' && obj[key] !== null) o[key] = obj[key]
    return o
  }
}

// 清空对象的属性值
export const clearObject = function(obj) {
  if (obj.constructor === Object) {
    let o = {}
    for (let key in obj) o[key] = ''
    return o
  }
}

// 复制文本
export const copy = function(ele) {
  if (!ele) return
  window.getSelection().removeAllRanges()
  const range = document.createRange()
  range.selectNode(ele)
  window.getSelection().addRange(range)
  document.execCommand('copy')
  window.getSelection().removeAllRanges()
  return true
}

//数组根据数组对象中的某个属性值进行排序的方法
export const compare = function(property, desc) {
  return function(a, b) {
    var value1 = a[property];
    var value2 = b[property];
    if (desc === true) {
      // 升序排列
      return value1 - value2;
    } else {
      // 降序排列
      return value2 - value1;
    }
  }
}
// arr.sort(compare('key', true))

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function getCss(curEle, attr) {
  let val = null,
    reg = null
  if ("getComputedStyle" in window) {
    val = window.getComputedStyle(curEle, null)[attr]
  } else {
    val = curEle.currentStyle[attr]
  }
  reg = /^(-?\d+(\.\d+)?)(px|pt|rem|em)?$/i
  return reg.test(val) ? parseFloat(val) : val
}

export function toStarString(s, isAllStar, bsType) { // isAllStar == true 全部* baseStar
  if (s === undefined || s === null || s.length === 0) return
  var str = s + ''
  var l = str.length
  var baseType = bsType || 0
  var baseStar = ''
  if (baseType === 0) baseStar = '**** '
  if (baseType === 1 || baseType === 2) baseStar = '****'
  var isAll = isAllStar || false
  if (baseType < 2) {
    if (l > 4) {
      var n = Math.floor((l - 4) / 4)
      var star = ''
      if (isAll) {
        for (let i = 0; i < l; i++) star += '*'
        return star
      } else {
        if (n === 0) n = 1
        for (let i = 0; i < n; i++) star += baseStar
        return star + str.substr(l - 4, l)
      }
    } else {
      return isAll ? '****' : ('**** ' + str.substr(2, 4))
    }
  } else {
    return str.substr(0, 2) + '***' + str.substr(l - 2, l)
  }
}


export function unique(arr, attrName) { // 数组去重
  const res = new Map();
  return arr.filter((a) => !res.has(a[attrName]) && res.set(a[attrName], 1));
}


export function getQueryFromHrefByName(name) { // 根据名称从地址栏获取参数
  var result = location.href.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
  if (result == null || result.length < 1) {
    return null
  }
  return result[1]
}

export function getQueryFromHref() {
  var result = location.search.match(new RegExp("[\?\&][^\?\&]+=[^\?\&]+", "g"));
  if (result == null) {
    return null
  }
  for (var i = 0; i < result.length; i++) {
    result[i] = result[i].substring(1);
  }
  return result;
}

// 计算对象数组某个属性的和
export function ArraryReduce(arr, attr) {
	return arr.reduce((sum, e) => sum + e[attr] * 1, 0)
}

export function scrollToTop(id = 'main-view', n = 0) { // 滚动到指定位置
  // 1.scrollTo(x,y)   //指定滚动到x轴和y轴的位置
  // 2.scrollTo(options)  //options有三个参数，（left,top,behavior ）,
  // top 等同于  y-coord
  // left 等同于  x-coord
  // behavior  类型String,表示滚动行为,支持参数 smooth(平滑滚动),instant(瞬间滚动),默认值auto,实测效果等同于instant
  if (document.getElementById(id)) {
    document.getElementById(id).scrollTo({ top: n, behavior: 'smooth' })
  }
}


// WEBPACK FOOTER //
// ./src/common/utils/index.js